var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.computed_class,attrs:{"href":_vm.representation,"target":"_blank"}},[_vm._v(_vm._s(_vm.representation))])
}
var staticRenderFns = []

export { render, staticRenderFns }